import { SELECIONAR_FECHAMENTO_CAIXA } from '../types';

export default function selecionarItemFechamento (data) {
  return {
    type: SELECIONAR_FECHAMENTO_CAIXA,
    payload: data
  }
}
